(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["martini-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CLASS_OPEN = 'is-open';
    const HASH_PREFIX = 'recipe-';
    let copyTimer = null;

    function recipeHandleFromHash(hash) {
      const raw = (hash || '').replace(/^#/, '');
      if (!raw.startsWith(HASH_PREFIX)) return null;
      return raw.slice(HASH_PREFIX.length) || null;
    }

    function recipeHash(handle) {
      return '#' + HASH_PREFIX + handle;
    }

    function recipeUrl(handle) {
      return window.location.origin + window.location.pathname + window.location.search + recipeHash(handle);
    }

    function setHash(handle) {
      const next = recipeHash(handle);
      if (window.location.hash === next) return;
      history.replaceState(null, '', next);
    }

    function clearHashIfRecipe() {
      if (!recipeHandleFromHash(window.location.hash)) return;
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    function findSlide(handle) {
      if (!handle) return null;
      const slides = document.querySelectorAll('.martini-slide[data-recipe="' + CSS.escape(handle) + '"]');
      for (const slide of slides) {
        if (!slide.classList.contains('swiper-slide-duplicate')) return slide;
      }
      return slides[0] || null;
    }

    function slideIndex(slide) {
      if (!slide) return -1;
      if (slide.dataset.recipeIndex != null && slide.dataset.recipeIndex !== '') {
        return Number(slide.dataset.recipeIndex);
      }
      if (slide.dataset.swiperSlideIndex != null && slide.dataset.swiperSlideIndex !== '') {
        return Number(slide.dataset.swiperSlideIndex);
      }
      return -1;
    }

    function goToRecipeSlide(slide) {
      const carousel = slide?.closest('carousel-slider');
      const index = slideIndex(slide);
      if (!slide) return;

      const scroll = () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      };

      // Mobile grid (destroyBelow) — no Swiper; just scroll the card into view.
      if (!carousel || index < 0 || !carousel.swiperInstance || carousel.swiperInstance.destroyed) {
        scroll();
        if (carousel && index >= 0) {
          carousel.addEventListener('carousel:ready', () => {
            if (typeof carousel.goToSlide === 'function') carousel.goToSlide(index, 0);
            scroll();
          }, { once: true });
        }
        return;
      }

      if (typeof carousel.goToSlide === 'function') {
        carousel.goToSlide(index, 0);
      }
      scroll();
    }

    function syncOverlayFocus(slide, open) {
      const inner = slide?.querySelector('.martini-slide__overlay-inner');
      const closeBtn = slide?.querySelector('.martini-slide__close');
      if (!inner) return;
      if (open) {
        inner.setAttribute('tabindex', '0');
        window.setTimeout(() => {
          (closeBtn || inner).focus({ preventScroll: true });
        }, 0);
      } else {
        inner.setAttribute('tabindex', '-1');
      }
    }

    function closeAll(except) {
      document.querySelectorAll('.martini-slide.' + CLASS_OPEN).forEach((el) => {
        if (el !== except) {
          el.classList.remove(CLASS_OPEN);
          syncOverlayFocus(el, false);
        }
      });
    }

    function openRecipe(handle, { updateHash = true, scroll = true } = {}) {
      const slide = findSlide(handle);
      if (!slide) return false;
      closeAll(slide);
      slide.classList.add(CLASS_OPEN);
      syncOverlayFocus(slide, true);
      if (scroll) goToRecipeSlide(slide);
      if (updateHash) setHash(handle);
      return true;
    }

    function applyHash() {
      const handle = recipeHandleFromHash(window.location.hash);
      if (!handle) return;
      openRecipe(handle, { updateHash: false, scroll: true });
    }

    function showCopied(link) {
      const cue = link.querySelector('.martini-slide__permalink-cue');
      if (cue) cue.textContent = 'Copied';
      link.classList.add('is-copied');
      clearTimeout(copyTimer);
      copyTimer = setTimeout(() => {
        link.classList.remove('is-copied');
        if (cue) cue.textContent = '';
      }, 1400);
    }

    document.addEventListener('click', (e) => {
      const permalink = e.target.closest('.martini-slide__permalink');
      if (permalink) {
        e.preventDefault();
        e.stopPropagation();
        const slide = permalink.closest('.martini-slide');
        const handle = slide?.dataset.recipe;
        if (!handle) return;
        setHash(handle);
        const url = recipeUrl(handle);
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(url).then(() => showCopied(permalink)).catch(() => {
            showCopied(permalink);
          });
        } else {
          showCopied(permalink);
        }
        return;
      }

      const closeBtn = e.target.closest('.martini-slide__close');
      if (closeBtn) {
        const slide = closeBtn.closest('.martini-slide');
        slide?.classList.remove(CLASS_OPEN);
        syncOverlayFocus(slide, false);
        if (slide && recipeHandleFromHash(window.location.hash) === slide.dataset.recipe) {
          clearHashIfRecipe();
        }
        return;
      }

      const slide = e.target.closest('.martini-slide');
      closeAll(slide);

      // Toggle the clicked slide. When closed (mobile default = image+title only),
      // any tap on the card opens the full recipe. When open, ignore taps on the
      // recipe copy so text stays selectable; use × / outside / Esc to close.
      if (slide && !e.target.closest('.martini-slide__overlay-inner')) {
        slide.classList.toggle(CLASS_OPEN);
        const isOpen = slide.classList.contains(CLASS_OPEN);
        syncOverlayFocus(slide, isOpen);
        if (isOpen && slide.dataset.recipe) {
          setHash(slide.dataset.recipe);
        } else if (recipeHandleFromHash(window.location.hash) === slide.dataset.recipe) {
          clearHashIfRecipe();
        }
      } else if (!slide) {
        // Click outside any slide — close open recipes + clear hash.
        document.querySelectorAll('.martini-slide.' + CLASS_OPEN).forEach((el) => {
          el.classList.remove(CLASS_OPEN);
          syncOverlayFocus(el, false);
        });
        if (recipeHandleFromHash(window.location.hash)) clearHashIfRecipe();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = document.querySelector('.martini-slide.' + CLASS_OPEN);
      document.querySelectorAll('.martini-slide.' + CLASS_OPEN).forEach((el) => {
        el.classList.remove(CLASS_OPEN);
        syncOverlayFocus(el, false);
      });
      if (open && recipeHandleFromHash(window.location.hash) === open.dataset.recipe) {
        clearHashIfRecipe();
      }
      open?.focus({ preventScroll: true });
    });

    window.addEventListener('hashchange', applyHash);

    function bindCarousels() {
      document.querySelectorAll('.martini-slider__carousel').forEach((carousel) => {
        if (carousel.dataset.recipeDeepLinkBound === '1') return;
        carousel.dataset.recipeDeepLinkBound = '1';
        if (carousel.swiperInstance && !carousel.swiperInstance.destroyed) {
          applyHash();
        } else {
          // Desktop: wait for Swiper. Mobile destroyBelow never fires ready — apply now.
          carousel.addEventListener('carousel:ready', applyHash, { once: true });
        }
      });
      // Fallback: grid layout / mobile stack / already painted / never fires ready again.
      applyHash();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindCarousels);
    } else {
      bindCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
